import React from 'react';
import { Container, Row, Col, CardImg } from 'reactstrap';

const Skills = (props) => {
  return (
    <div className="py-5 my-5 text-center">
      <Container style={{ backgroundColor: 'rgba(71, 70, 76, 0.7)', borderRadius: '20px' }}>
        <Container>
          <Row>
            <Col>
              <h1>Skills Every Cybersecurity Professional Should Have</h1>
              <p>As technology and information advances, you’ll need to advance your skills, too.</p>
              <hr style={{ backgroundColor: '#FFBD00' }} />
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <h3 style={{ backgroundColor: 'rgba(38, 39, 45, 0.9)', borderRadius: '8px', padding: '5px' }}>Network Intrusion</h3>
            </Col>
            <Col>
              <h3 style={{ backgroundColor: 'rgba(38, 39, 45, 0.9)', borderRadius: '8px', padding: '5px' }}>Database Management</h3>
            </Col>
            <Col>
              <h3 style={{ backgroundColor: 'rgba(38, 39, 45, 0.9)', borderRadius: '8px', padding: '5px' }}>Packet Analysis</h3>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <h3 style={{ backgroundColor: 'rgba(38, 39, 45, 0.9)', borderRadius: '8px', padding: '5px' }}>Password Storage Best Practices</h3>
            </Col>
            <Col>
              <h3 style={{ backgroundColor: 'rgba(38, 39, 45, 0.9)', borderRadius: '8px', padding: '5px' }}>Machine Learning</h3>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <h3 style={{ backgroundColor: 'rgba(38, 39, 45, 0.9)', borderRadius: '8px', padding: '5px' }}>Metasploit</h3>
            </Col>
            <Col>
              <h3 style={{ backgroundColor: 'rgba(38, 39, 45, 0.9)', borderRadius: '8px', padding: '5px' }}>Threat Intelligence</h3>
            </Col>
            <Col>
              <h3 style={{ backgroundColor: 'rgba(38, 39, 45, 0.9)', borderRadius: '8px', padding: '5px' }}>Hashing Algorithms</h3>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <h3 style={{ backgroundColor: 'rgba(38, 39, 45, 0.9)', borderRadius: '8px', padding: '5px' }}>Network Monitoring</h3>
            </Col>
            <Col>
              <h3 style={{ backgroundColor: 'rgba(38, 39, 45, 0.9)', borderRadius: '8px', padding: '5px' }}>Encryption and Decryption</h3>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <h3 style={{ backgroundColor: 'rgba(38, 39, 45, 0.9)', borderRadius: '8px', padding: '5px' }}>Data Recovery</h3>
            </Col>
            <Col>
              <h3 style={{ backgroundColor: 'rgba(38, 39, 45, 0.9)', borderRadius: '8px', padding: '5px' }}>Digital Forensics</h3>
            </Col>
            <Col>
              <h3 style={{ backgroundColor: 'rgba(38, 39, 45, 0.9)', borderRadius: '8px', padding: '5px' }}>Wireshark</h3>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  )
}

export default Skills;
